import { client } from '../../../../actions';
import { authHeader } from '../../../../helpers/auth-header';

const setDefaultFilter = (id) => {
  return client.put(
    '/Filter/default',
    { id, value: true },
    { headers: authHeader() }
  );
};

export default setDefaultFilter;
